// extracted by mini-css-extract-plugin
export default {"toggler":"root_toggler-module__toggler___apanV","open":"root_toggler-module__open___ngGDC"};